import { createValidate } from 'typia'
import { validateGuard } from 'components/shared/parsing/parsing.js'

export type IRmaOverviewItemDTO = {
  rma_id: string
  // number/sent/user_email can be null for drafts or ERP-synced RMAs; keep them
  // nullable so one such row can't fail validation and blank the whole overview
  number: string | null
  erp_reference: string | null
  sent: string | null
  last_update: string | null
  state: string
  status: string
  user: string
  user_email: string | null
}

export type IRmaOverviewPaginatorDTO = {
  page: number
  num_pages: number
  first_page_link: string
  prev_page_link: string
  next_page_link: string
  last_page_link: string
}

export type IRmaOverviewDTO = {
  items: IRmaOverviewItemDTO[]
  paginator: IRmaOverviewPaginatorDTO
}

export class RmaOverviewItemDTO {
  rmaId: string
  number: string | null
  erpReference: string | null
  sent: string | null
  lastUpdate: string | null
  state: string
  status: string
  user: string
  userEmail: string | null

  constructor(data: IRmaOverviewItemDTO) {
    this.rmaId = data.rma_id
    this.number = data.number
    this.erpReference = data.erp_reference
    this.sent = data.sent
    this.lastUpdate = data.last_update
    this.state = data.state
    this.status = data.status
    this.user = data.user
    this.userEmail = data.user_email
  }
}

export class RmaOverviewPaginatorDTO {
  page: number
  numPages: number
  firstPageLink: string
  prevPageLink: string
  nextPageLink: string
  lastPageLink: string

  constructor(data: IRmaOverviewPaginatorDTO) {
    this.page = data.page
    this.numPages = data.num_pages
    this.firstPageLink = data.first_page_link
    this.prevPageLink = data.prev_page_link
    this.nextPageLink = data.next_page_link
    this.lastPageLink = data.last_page_link
  }
}

export class RmaOverviewDTO {
  items: RmaOverviewItemDTO[]
  paginator: RmaOverviewPaginatorDTO

  constructor(data: IRmaOverviewDTO) {
    this.items = data.items.map((item) => new RmaOverviewItemDTO(item))
    this.paginator = new RmaOverviewPaginatorDTO(data.paginator)
  }
}

const validate = createValidate<IRmaOverviewDTO>()

export const parseRmaOverviewDTO = (data: unknown): RmaOverviewDTO => {
  validateGuard(validate, data, 'rma overview')
  return new RmaOverviewDTO(data)
}
